<template>
  <b-container fluid>
    <b-row>
      <select-installations-tab-filter
        :customCompanies="customCompanies"
        :customRegional="customRegional"
        :show-regional-when-empty="showRegionalWhenEmpty"
        :loading-installations="loadingInstallations"
        @search-installations="search"
        @get-oscilography-regional="getCustomRegional"
      />
    </b-row>
    <paged-grid
      class="mt-3"
      configuration-mode
      v-model="valueHandler"
      v-bind="pagedGridOptions"
      :backup="backup"
      :pagination="pagination"
      :loading="loadingInstallations"
      :main-table-fields="fields"
      :selected-items="selectedTotal"
      :main-table-items="installations"
      @update:main-table-items="updateInstallations"
      @page-changed="paginate"
    />
    <slot name="grid-footer" />
  </b-container>
</template>
<script>
import PagedGrid from '../PagedGrid';
import SelectInstallationsTabFilter from './Filters';

export default {
  name: 'SelectedInstallation',
  props: {
    /**
     * Array de instalações que serão exibidas na grid, deve seguir o modelo como no exemplo abaixo:
     * @example
     * [{
     *   selected: Boolean,
     *   installationName: String,
     *   companyName: String,
     *   regionalName: String,
     * }]
     */
    selectedTotal: {
      type: Array,
      default: () => [],
    },
    installations: {
      type: Array,
    },
    customCompanies: {
      type: Array,
    },
    customRegional: {
      type: Array,
    },
    backup: {
      type: Array,
    },
    value: {
      type: Array,
    },
    /**
     * Booleano indicando se as instalações estão carregando ainda, exibe um loading na tabela.
     */
    loadingInstallations: {
      type: Boolean,
    },
    showRegionalWhenEmpty: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Object,
      default: () => ({
        perPage: 200,
        totalRows: 200,
        currentPage: 1,
      }),
    },
    /**
     * Proxy para customizar propriedades do componente de grid paginada.
     * É passado por v-bind para o componente.
     */
    pagedGridOptions: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  components: {
    PagedGrid,
    SelectInstallationsTabFilter,
  },
  computed: {
    valueHandler: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    fields() {
      return [
        {
          key: 'check',
        },
        {
          key: 'installationName',
          label: this.$t('my-sigma.select-installations-tab.installation'),
        },
        {
          key: 'regionalName',
          label: this.$t('my-sigma.select-installations-tab.regional'),
        },
        {
          key: 'companyName',
          label: this.$t('my-sigma.select-installations-tab.company'),
        },
      ];
    },
  },
  methods: {
    getCustomRegional(companies) {
      const companiesIds = companies.map(({ id }) => id);
      this.$emit('get-oscilography-regional', companiesIds);
    },
    search(filter) {
      this.$emit('search-installations', filter);
    },
    paginate(page) {
      this.$emit('page-changed', page);
    },
    updateInstallations(event) {
      this.$emit('update:installations', event);
    },
  },
};
</script>
